// extracted by mini-css-extract-plugin
export default {"container":"SPTable_container__CgaUK","table":"SPTable_table__h-sqi","border":"SPTable_border__drKW+"};